// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetFupOrganisationLogoRequestModel from '../../model/get-fup-organisation-logo-request-model';
import GetFupOrganisationLogoRequestDTO from '../dto/get-fup-organisation-logo-request-dto';
import dtoSchema from '../schemas/get-fup-organisation-logo-request-schema';

export default abstract class GetFupOrganisationLogoRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetFupOrganisationLogoRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {uuid}
  */
  id?: string;

  static toModel(dto: DeepPartial<GetFupOrganisationLogoRequestDTO>): GetFupOrganisationLogoRequestModel;
  static toModel(dto: DeepPartial<GetFupOrganisationLogoRequestDTO> | undefined | null): GetFupOrganisationLogoRequestModel | undefined;
  static toModel(dto: DeepPartial<GetFupOrganisationLogoRequestDTO> | undefined | null): GetFupOrganisationLogoRequestModel | undefined {
    return dto ? new GetFupOrganisationLogoRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetFupOrganisationLogoRequestModel> | GetFupOrganisationLogoRequestModel): GetFupOrganisationLogoRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetFupOrganisationLogoRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetFupOrganisationLogoRequestModel, can not map to GetFupOrganisationLogoRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
